// Manager Approve is a custom-body popup: ManagerApproveBody owns its own
// submit (native approve/reject via the finance panel's action bar), so the
// framework-level submit is a no-op. Kept for POPUP registration symmetry.
export const api = {
  submit: async () => {},
};
